import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class DailyCountWeeklyWidgetVm {
	scheduled: number;
	completed: number;
	pending?: number;
	missed?: number;
	percentComplete: number;
	percentPending: number;
	percentMissed: number;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'scheduled': new UntypedFormControl(0, [...(validators['scheduled'] ?? []), ...[Validators.required]]),
			'completed': new UntypedFormControl(0, [...(validators['completed'] ?? []), ...[Validators.required]]),
			'pending': new UntypedFormControl(null, [...(validators['pending'] ?? []), ...[]]),
			'missed': new UntypedFormControl(null, [...(validators['missed'] ?? []), ...[]]),
			'percentComplete': new UntypedFormControl(0, [...(validators['percentComplete'] ?? []), ...[Validators.required]]),
			'percentPending': new UntypedFormControl(0, [...(validators['percentPending'] ?? []), ...[Validators.required]]),
			'percentMissed': new UntypedFormControl(0, [...(validators['percentMissed'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): DailyCountWeeklyWidgetVmFromFg {
		return new DailyCountWeeklyWidgetVmFromFg(fg);
	}
}

export class DailyCountWeeklyWidgetVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get scheduled(): number {
		return this.fg.get('scheduled').value;
	}
	set scheduled(val) {
		this.fg.get('scheduled').setValue(val);
	}

	get completed(): number {
		return this.fg.get('completed').value;
	}
	set completed(val) {
		this.fg.get('completed').setValue(val);
	}

	get pending(): number {
		return this.fg.get('pending').value;
	}
	set pending(val) {
		this.fg.get('pending').setValue(val);
	}

	get missed(): number {
		return this.fg.get('missed').value;
	}
	set missed(val) {
		this.fg.get('missed').setValue(val);
	}

	get percentComplete(): number {
		return this.fg.get('percentComplete').value;
	}
	set percentComplete(val) {
		this.fg.get('percentComplete').setValue(val);
	}

	get percentPending(): number {
		return this.fg.get('percentPending').value;
	}
	set percentPending(val) {
		this.fg.get('percentPending').setValue(val);
	}

	get percentMissed(): number {
		return this.fg.get('percentMissed').value;
	}
	set percentMissed(val) {
		this.fg.get('percentMissed').setValue(val);
	}
}
